import { ConfirmModalProps } from '@hevoio/hevo-ui-toolkit';

export type DeleteConfirmProps = Partial<ConfirmModalProps<object, object>>;

/**
 * Styling shared by every delete confirmation, per Figma 8546-70748: the bin
 * glyph and the question share the title row, and the CTA is a solid error
 * button carrying the bin icon.
 *
 * Only the styling lives here — each caller supplies its own title, body and
 * button copy. Spread it rather than restating the four props, so the dialogs
 * cannot drift (Models, dbt Projects, and the Schema Explorer's Delete Table).
 */
export const DELETE_CONFIRM_BASE: DeleteConfirmProps = {
  iconName: 'delete',
  // ConfirmModal's RoundIcon defaults to a filled container with a white glyph;
  // the design shows the plain glyph in the text colour.
  iconProps: { hasBg: false, isIconColorWhite: false },
  positiveButtonPalette: 'error',
  positiveBtnProps: { icon: 'delete' }
};

/**
 * The Edge entity-delete variant: an error-coloured question title with no icon and a faded
 * error CTA. Shared by the Edge entity actions factory and Workflows so the two cannot drift.
 */
export const DELETE_CONFIRM_TEXT_ERROR: DeleteConfirmProps = {
  titleContainerClassName: 'text-error',
  positiveButtonClass: 'btn-error',
  positiveButtonVariation: 'faded',
  positiveButtonPalette: 'error',
  positiveBtnProps: { icon: 'delete' }
};
